import { render, staticRenderFns } from "./MessagesSettings.vue?vue&type=template&id=31c4c1ae"
import script from "./MessagesSettings.vue?vue&type=script&lang=js"
export * from "./MessagesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports